

import React, { memo } from 'react';
import cx from 'classnames';
import Icon from '../../Icon';
import { BUTTON, ICON, ICON_CONTAINER } from '../styles/actionButton';










/**
 * An action button react component. The icon is clickable but the label is not.
 *
 * @param {func} onClick
 * @param {bool} visible
 *
 * @return {React.Element}
 */
function ActionButton(
{ onClick, visible, icon, labelText, className, iconColor, iconSize })
{
  return (
    <div className={cx(BUTTON, 'action-button', className)}>
      {visible ?

      <div className={cx(ICON_CONTAINER)}>
            <Icon
          color={iconColor || 'regent'}
          onClick={onClick}
          className={cx(ICON, 'action__button__icon')}
          name={icon}
          size={iconSize} />

            <p>{labelText}</p>
          </div> :

      null}

    </div>);

}

ActionButton.defaultProps = {
  onClick: void 0,
  visible: true,
  icon: '',
  labelText: ''
};

export default memo(ActionButton);